<!--
Wrapping the grid like this should greatly simplify the concerns in both the panel and grid components.
With this design the grid will only be created when it is ready to request data and it will be destroyed when the
active session is changed. Now the panel and grid no longer need to worry about when the grid can request data or worry
about resetting filters/sorting/grouping on new account loads. This should make adding additional features to the grid
easier.
-->
<!--
  When the consumer declares the wrapped content not applicable for the active session
  this is a terminal state: we render a static message card and never create the content,
  so no row request is ever issued and no cache placeholder is ever shown.
-->
<ng-container *ngIf="notApplicable; else awaitCacheStatus">
  <hs-panel-card [header]="notApplicableHeader">
    <p>{{ notApplicableMessage }}</p>
  </hs-panel-card>
</ng-container>

<ng-template #awaitCacheStatus>
  <div
    *ngIf="cacheReady; else awaitCacheReady"
    class="d-flex flex-column w-100 h-100"
  >
    <!--https://medium.com/@pietmichal/angulars-content-projection-trap-and-why-you-should-consider-using-template-outlet-instead-cc3c4cad87c9-->
    <ng-template [ngTemplateOutlet]="content"></ng-template>
  </div>
</ng-template>

<ng-template #awaitCacheReady>
  <!-- 
      Render the error template if an error exists, otherwise continue to 
      render the hs-panel-card 
  -->
  <ng-container *ngIf="!hasError; else cacheLoadError">
    <hs-panel-card header="Loading Cache..." [isLoading]="!cacheReady">
      <p>
        This panel requires data to be hydrated in the back end service prior to
        requesting data.
      </p>
    </hs-panel-card>
  </ng-container>
</ng-template>

<ng-template #cacheLoadError>
  <hs-panel-card
    header="Cache Load Error"
    icon="mdi-alert-circle"
    iconClass="text-danger"
  >
    <p>
      This panel has encountered an error while attempting to load data from the
      back end service.
    </p>
    <p *ngIf="sessionId">Session ID: {{ sessionId }}</p>
    <ng-container *ngIf="accountIds">
      <p *ngIf="accountIds.length == 1">
        Account ID: {{ accountIds.join(', ') }}
      </p>
      <p *ngIf="accountIds.length > 1">
        Account IDs: {{ accountIds.join(', ') }}
      </p>
    </ng-container>
  </hs-panel-card>
</ng-template>
